<!-- This component hides/shows the product caption depending on the section settings & product availability online -->
<template>
  <div v-show="findInStoreProduct" class="product-info-caption">
    {{ translations.caption }}
  </div>
</template>

<script>
import productCTAButtonsMixin from '../../mixins/productCTAButtonsMixin';

export default {
  mixins: [productCTAButtonsMixin],
  props: {
    product: {
      type: Object,
      required: true
    },
    metafields: {
      type: Object,
      required: true
    },
    translations: {
      type: Object,
      required: true
    }
  },
  computed: {
    findInStoreProduct() {
      return this.canFindInStore && !this.canAddProduct;
    }
  }
};
</script>
